export class ScholarshipOS {
    constructor(public data: {
        StartTime?: String,
        EndTime?: String,
        Age?: Number,
        Gender?: String,
        Duration?: Number,
        HazardLevel?: Number,
        PaymentFrequency?: Number,
        CigarettesPerDay?: Number,
        Height?: Number,
        Weight?: Number,
        DeathByAccident?: Number,
        InvalidityByAccident?: Number,
        Surgery?: Number,
        MonthlyRent?: Number,
        DailyFee?: Number,
        TreatmanExpenses?: Number,
        IncludeMSO?: Boolean,
        IncludeDNA?: Boolean,
        AdditionalInsurance?: Boolean,
        SelectedPackage?: Number,
        PaymentPeriodOut?: Number,
        PaymentPeriodIn?: Number,
        PremiumRate?: Number,
        AdditionalInsuranceDeath?: Boolean,
        riderDeath?: Number,
        tbType?: Number,
        riderTB?: Number
    }) { }
}